import React from "react"
import PropTypes from "prop-types"

import { withStyles } from "@material-ui/core/styles"
import classnames from "classnames"

export const styleSheet = theme => ({
  root: {
    flex: [0, 0, "auto"],
    zIndex: theme.zIndex.appBar,
    position: "relative",
  },
})

export class ScrollFrameFooter extends React.PureComponent {
  static propTypes = {
    classes: PropTypes.object,
    scrolled: PropTypes.bool,
  }

  render() {
    const {
      classes,
      className: classNameProp,
      scrolled,

      ...otherProps
    } = this.props

    const className = classnames(
      classes.root,
      {
        [classes.scrolled]: scrolled,
      },
      classNameProp
    )

    return <div {...otherProps} className={className} />
  }
}

export default withStyles(styleSheet)(ScrollFrameFooter)



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-ScrollFrame/ScrollFrameFooter.js